import { AddRecommendationItemJsEnv, RecommendationItemFoldersAPI } from './add_recommendation_item_js_env';
import { FolderType, RecommendationItemFolder} from './folders';

export class AddRecommendationItem {
  private static readonly MAX_FOLDER_NAME_COUNT = 20;

  constructor(private model: AddRecommendationItemJsEnv) {
    this.model = { ...model };
  }

  updateModel(newModel: AddRecommendationItemJsEnv) {
    this.model = { ...newModel };
  }

  getModel(): AddRecommendationItemJsEnv {
    return {
      ...this.model
    };
  }

  setCompanyId(id: string) {
    this.model.companyId = id;
  }

  setDepartmentId(id: string) {
    this.model.departmentId = id;
  }

  setFolderShareType(type: FolderType) {
    this.model.folderShareType = type;
  }

  setRecommendationFolderName(name: string) {
    this.model.recommendationFolderName = name;
  }

  setIsLoadedCompanyFolders(bool: boolean) {
    this.model.isLoadedCompanyFolders = bool;
  }

  setIsLoadedDepartmentFolders(bool: boolean) {
    this.model.isLoadedDepartmentFolders = bool;
  }

  setIsWarningHidden(bool: boolean) {
    this.model.isWarningHidden = bool;
  }

  setWarningMessage(msg: string) {
    this.model.warningMessage = msg;
  }

  setMarginCount(num: number) {
    this.model.marginCount = AddRecommendationItem.MAX_FOLDER_NAME_COUNT - num;
  }

  resetMarginCount() {
    this.model.marginCount = AddRecommendationItem.MAX_FOLDER_NAME_COUNT;
  }

  isFolderNameEmpty() {
    return this.model.marginCount === AddRecommendationItem.MAX_FOLDER_NAME_COUNT;
  }

  setIsCreateFolderWarningHidden(bool: boolean) {
    this.model.isCreateFolderWarningHidden = bool;
  }

  setCompanyRecommendationFolders(companyRecommendationFolders: RecommendationItemFolder[]) {
    this.model.companyRecommendationFolders = companyRecommendationFolders;
  }

  setDepartmentRecommendationFolders(departmentRecommendationFolders: RecommendationItemFolder[]) {
    this.model.departmentRecommendationFolders = departmentRecommendationFolders;
  }

  setSupplierId(supplierId: string) {
    this.model.supplierId = supplierId;
  }

  setRecommendationItemFoldersApiResult(apiResult: RecommendationItemFoldersAPI) {
    this.model.recommendationItemFoldersApiResult = apiResult;
  }

  getSupplierId() {
    return this.model.supplierId;
  }

  setCatalogItemCode(catalogItemCode: string) {
    this.model.catalogItemCode = catalogItemCode;
  }

  getCatalogItemCode() {
    return this.model.catalogItemCode;
  }

  setVariationCode(variationCode: string) {
    this.model.variationCode = variationCode;
  }

  getVariationCode() {
    return this.model.variationCode;
  }
}
